import { defineMessages } from './define'

/* The desk's one-step bill (qb.*): a name, what they came for, take the money. */

export default defineMessages({
  en: {
    'qb.title': 'New bill',
    'qb.sub': 'A name is enough. Pick what they came for and take the money.',
    'qb.patient': 'Patient',
    'qb.name': 'Name',
    'qb.namePh': 'Patient’s name',
    'qb.required': 'required',
    'qb.optional': 'optional',
    'qb.gender': 'Gender',
    'qb.female': 'Female',
    'qb.male': 'Male',
    'qb.other': 'Other',
    'qb.age': 'Age',
    'qb.agePh': 'Years',
    'qb.already': 'Already registered?',
    'qb.change': 'Change',
    'qb.consultation': 'Consultation',
    'qb.noDoctors': 'No doctors set up yet.',
    'qb.labTests': 'Lab tests',
    'qb.findTest': 'Find a test',
    'qb.noPrice': 'No price set',
    'qb.noTests': 'No test matches.',
    'qb.another': 'Another charge',
    'qb.whatFor': 'What is it for',
    'qb.bill': 'Bill',
    'qb.empty': 'Nothing added yet. Tap a doctor or a test.',
    'qb.total': 'Total',
    'qb.cash': 'Cash',
    'qb.upi': 'UPI',
    'qb.card': 'Card',
    'qb.cashReceived': 'Cash received',
    'qb.changeToGive': 'Change to give: {amount}',
    'qb.upiRef': 'UPI reference',
    'qb.cardRef': 'Card slip number',
    'qb.collect': 'Collect {amount}',
    'qb.saveBill': 'Save bill',
    'qb.saveUnpaid': 'Save unpaid',
    'qb.saving': 'Saving…',
    'qb.paid': 'Paid',
    'qb.saved': 'Bill saved',
    'qb.paidNote': 'Hand over the receipt.',
    'qb.savedNote': 'Saved unpaid. Collect it from Bills when the patient pays.',
    'qb.newBill': 'New bill',
    'qb.shareReceipt': 'Share receipt',
    'qb.allBills': 'All bills',
    'qb.labOnSheet_one': 'The test is on today’s lab sheet.',
    'qb.labOnSheet_other': '{n} tests are on today’s lab sheet.',
    'qb.billNo': 'Bill {no}',
    'qb.receiptNo': 'Receipt {no}',
    'qb.paidBy': 'Paid by {mode}',
    'qb.cashChange': 'Cash received · change',
    'qb.due': 'Due',
    'qb.tabBill': 'Bill',
    'qb.tabBills': 'Bills',
    'qb.couldNotSave': 'Could not save the bill.',
    'qb.b.name': 'Enter the patient’s name.',
    'qb.b.lines': 'Add a consultation or a test.',
    'qb.b.price': 'Every line needs a price.',
    'qb.b.desc': 'Describe the extra charge.',
    'qb.b.cash': 'Cash received is less than the bill.',
  },
  hi: {
    'qb.title': 'नया बिल',
    'qb.sub': 'सिर्फ़ नाम काफ़ी है। जिस काम के लिए आए हैं वह चुनें और पैसे लें।',
    'qb.patient': 'मरीज़',
    'qb.name': 'नाम',
    'qb.namePh': 'मरीज़ का नाम',
    'qb.required': 'ज़रूरी',
    'qb.optional': 'वैकल्पिक',
    'qb.gender': 'लिंग',
    'qb.female': 'महिला',
    'qb.male': 'पुरुष',
    'qb.other': 'अन्य',
    'qb.age': 'उम्र',
    'qb.agePh': 'साल',
    'qb.already': 'पहले से रजिस्टर्ड?',
    'qb.change': 'बदलें',
    'qb.consultation': 'परामर्श',
    'qb.noDoctors': 'अभी कोई डॉक्टर जोड़ा नहीं गया।',
    'qb.labTests': 'लैब जाँच',
    'qb.findTest': 'जाँच खोजें',
    'qb.noPrice': 'कीमत तय नहीं',
    'qb.noTests': 'कोई जाँच नहीं मिली।',
    'qb.another': 'दूसरा शुल्क',
    'qb.whatFor': 'किसके लिए',
    'qb.bill': 'बिल',
    'qb.empty': 'अभी कुछ नहीं जोड़ा। डॉक्टर या जाँच पर टैप करें।',
    'qb.total': 'कुल',
    'qb.cash': 'नकद',
    'qb.upi': 'UPI',
    'qb.card': 'कार्ड',
    'qb.cashReceived': 'मिली नकद राशि',
    'qb.changeToGive': 'लौटाने हैं: {amount}',
    'qb.upiRef': 'UPI रेफ़रेंस',
    'qb.cardRef': 'कार्ड स्लिप नंबर',
    'qb.collect': '{amount} लें',
    'qb.saveBill': 'बिल सेव करें',
    'qb.saveUnpaid': 'बिना भुगतान सेव करें',
    'qb.saving': 'सेव हो रहा है…',
    'qb.paid': 'भुगतान हो गया',
    'qb.saved': 'बिल सेव हुआ',
    'qb.paidNote': 'रसीद दे दें।',
    'qb.savedNote': 'बिना भुगतान सेव हुआ। मरीज़ पैसे दे तो बिल से लें।',
    'qb.newBill': 'नया बिल',
    'qb.shareReceipt': 'रसीद भेजें',
    'qb.allBills': 'सभी बिल',
    'qb.labOnSheet_one': 'जाँच आज की लैब शीट पर है।',
    'qb.labOnSheet_other': '{n} जाँचें आज की लैब शीट पर हैं।',
    'qb.billNo': 'बिल {no}',
    'qb.receiptNo': 'रसीद {no}',
    'qb.paidBy': '{mode} से भुगतान',
    'qb.cashChange': 'मिली नकद · लौटाए',
    'qb.due': 'बाकी',
    'qb.tabBill': 'बिल',
    'qb.tabBills': 'बिल सूची',
    'qb.couldNotSave': 'बिल सेव नहीं हो सका।',
    'qb.b.name': 'मरीज़ का नाम लिखें।',
    'qb.b.lines': 'परामर्श या जाँच जोड़ें।',
    'qb.b.price': 'हर लाइन की कीमत चाहिए।',
    'qb.b.desc': 'दूसरे शुल्क का विवरण लिखें।',
    'qb.b.cash': 'मिली नकद राशि बिल से कम है।',
  },
  mr: {
    'qb.title': 'नवीन बिल',
    'qb.sub': 'फक्त नाव पुरेसे आहे. ते कशासाठी आले ते निवडा आणि पैसे घ्या.',
    'qb.patient': 'रुग्ण',
    'qb.name': 'नाव',
    'qb.namePh': 'रुग्णाचे नाव',
    'qb.required': 'आवश्यक',
    'qb.optional': 'ऐच्छिक',
    'qb.gender': 'लिंग',
    'qb.female': 'स्त्री',
    'qb.male': 'पुरुष',
    'qb.other': 'इतर',
    'qb.age': 'वय',
    'qb.agePh': 'वर्षे',
    'qb.already': 'आधीच नोंदणी झाली आहे?',
    'qb.change': 'बदला',
    'qb.consultation': 'सल्ला',
    'qb.noDoctors': 'अजून डॉक्टर जोडलेले नाहीत.',
    'qb.labTests': 'लॅब तपासण्या',
    'qb.findTest': 'तपासणी शोधा',
    'qb.noPrice': 'किंमत ठरलेली नाही',
    'qb.noTests': 'कोणतीही तपासणी सापडली नाही.',
    'qb.another': 'इतर शुल्क',
    'qb.whatFor': 'कशासाठी',
    'qb.bill': 'बिल',
    'qb.empty': 'अजून काही जोडले नाही. डॉक्टर किंवा तपासणीवर टॅप करा.',
    'qb.total': 'एकूण',
    'qb.cash': 'रोख',
    'qb.upi': 'UPI',
    'qb.card': 'कार्ड',
    'qb.cashReceived': 'मिळालेली रोख',
    'qb.changeToGive': 'परत द्यायचे: {amount}',
    'qb.upiRef': 'UPI संदर्भ',
    'qb.cardRef': 'कार्ड स्लिप क्रमांक',
    'qb.collect': '{amount} घ्या',
    'qb.saveBill': 'बिल जतन करा',
    'qb.saveUnpaid': 'न भरलेले जतन करा',
    'qb.saving': 'जतन होत आहे…',
    'qb.paid': 'भरले',
    'qb.saved': 'बिल जतन झाले',
    'qb.paidNote': 'पावती द्या.',
    'qb.savedNote': 'न भरता जतन झाले. रुग्णाने पैसे दिल्यावर बिलातून घ्या.',
    'qb.newBill': 'नवीन बिल',
    'qb.shareReceipt': 'पावती पाठवा',
    'qb.allBills': 'सर्व बिले',
    'qb.labOnSheet_one': 'तपासणी आजच्या लॅब शीटवर आहे.',
    'qb.labOnSheet_other': '{n} तपासण्या आजच्या लॅब शीटवर आहेत.',
    'qb.billNo': 'बिल {no}',
    'qb.receiptNo': 'पावती {no}',
    'qb.paidBy': '{mode} ने भरले',
    'qb.cashChange': 'मिळालेली रोख · परत',
    'qb.due': 'बाकी',
    'qb.tabBill': 'बिल',
    'qb.tabBills': 'बिले',
    'qb.couldNotSave': 'बिल जतन करता आले नाही.',
    'qb.b.name': 'रुग्णाचे नाव लिहा.',
    'qb.b.lines': 'सल्ला किंवा तपासणी जोडा.',
    'qb.b.price': 'प्रत्येक ओळीला किंमत हवी.',
    'qb.b.desc': 'इतर शुल्काचे वर्णन लिहा.',
    'qb.b.cash': 'मिळालेली रोख बिलापेक्षा कमी आहे.',
  },
  or: {
    'qb.title': 'ନୂଆ ବିଲ',
    'qb.sub': 'କେବଳ ନାମ ଯଥେଷ୍ଟ। କଣ ପାଇଁ ଆସିଛନ୍ତି ବାଛନ୍ତୁ ଓ ଟଙ୍କା ନିଅନ୍ତୁ।',
    'qb.patient': 'ରୋଗୀ',
    'qb.name': 'ନାମ',
    'qb.namePh': 'ରୋଗୀଙ୍କ ନାମ',
    'qb.required': 'ଆବଶ୍ୟକ',
    'qb.optional': 'ଇଚ୍ଛାଧୀନ',
    'qb.gender': 'ଲିଙ୍ଗ',
    'qb.female': 'ମହିଳା',
    'qb.male': 'ପୁରୁଷ',
    'qb.other': 'ଅନ୍ୟ',
    'qb.age': 'ବୟସ',
    'qb.agePh': 'ବର୍ଷ',
    'qb.already': 'ଆଗରୁ ପଞ୍ଜୀକୃତ?',
    'qb.change': 'ବଦଳାନ୍ତୁ',
    'qb.consultation': 'ପରାମର୍ଶ',
    'qb.noDoctors': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଡାକ୍ତର ଯୋଡ଼ାଯାଇନାହିଁ।',
    'qb.labTests': 'ଲ୍ୟାବ ପରୀକ୍ଷା',
    'qb.findTest': 'ପରୀକ୍ଷା ଖୋଜନ୍ତୁ',
    'qb.noPrice': 'ଦାମ ସ୍ଥିର ହୋଇନାହିଁ',
    'qb.noTests': 'କୌଣସି ପରୀକ୍ଷା ମିଳିଲା ନାହିଁ।',
    'qb.another': 'ଅନ୍ୟ ଶୁଳ୍କ',
    'qb.whatFor': 'କଣ ପାଇଁ',
    'qb.bill': 'ବିଲ',
    'qb.empty': 'ଏପର୍ଯ୍ୟନ୍ତ କିଛି ଯୋଡ଼ାଯାଇନାହିଁ। ଡାକ୍ତର ବା ପରୀକ୍ଷାରେ ଟ୍ୟାପ କରନ୍ତୁ।',
    'qb.total': 'ମୋଟ',
    'qb.cash': 'ନଗଦ',
    'qb.upi': 'UPI',
    'qb.card': 'କାର୍ଡ',
    'qb.cashReceived': 'ମିଳିଥିବା ନଗଦ',
    'qb.changeToGive': 'ଫେରାଇବାକୁ: {amount}',
    'qb.upiRef': 'UPI ରେଫରେନ୍ସ',
    'qb.cardRef': 'କାର୍ଡ ସ୍ଲିପ ନମ୍ବର',
    'qb.collect': '{amount} ନିଅନ୍ତୁ',
    'qb.saveBill': 'ବିଲ ସେଭ କରନ୍ତୁ',
    'qb.saveUnpaid': 'ଦେୟ ବିନା ସେଭ କରନ୍ତୁ',
    'qb.saving': 'ସେଭ ହେଉଛି…',
    'qb.paid': 'ଦେୟ ହୋଇଗଲା',
    'qb.saved': 'ବିଲ ସେଭ ହେଲା',
    'qb.paidNote': 'ରସିଦ ଦିଅନ୍ତୁ।',
    'qb.savedNote': 'ଦେୟ ବିନା ସେଭ ହେଲା। ରୋଗୀ ଟଙ୍କା ଦେଲେ ବିଲରୁ ନିଅନ୍ତୁ।',
    'qb.newBill': 'ନୂଆ ବିଲ',
    'qb.shareReceipt': 'ରସିଦ ପଠାନ୍ତୁ',
    'qb.allBills': 'ସବୁ ବିଲ',
    'qb.labOnSheet_one': 'ପରୀକ୍ଷା ଆଜିର ଲ୍ୟାବ ସିଟରେ ଅଛି।',
    'qb.labOnSheet_other': '{n}ଟି ପରୀକ୍ଷା ଆଜିର ଲ୍ୟାବ ସିଟରେ ଅଛି।',
    'qb.billNo': 'ବିଲ {no}',
    'qb.receiptNo': 'ରସିଦ {no}',
    'qb.paidBy': '{mode} ରେ ଦେୟ',
    'qb.cashChange': 'ମିଳିଥିବା ନଗଦ · ଫେରସ୍ତ',
    'qb.due': 'ବାକି',
    'qb.tabBill': 'ବିଲ',
    'qb.tabBills': 'ବିଲ ତାଲିକା',
    'qb.couldNotSave': 'ବିଲ ସେଭ ହୋଇପାରିଲା ନାହିଁ।',
    'qb.b.name': 'ରୋଗୀଙ୍କ ନାମ ଲେଖନ୍ତୁ।',
    'qb.b.lines': 'ପରାମର୍ଶ ବା ପରୀକ୍ଷା ଯୋଡ଼ନ୍ତୁ।',
    'qb.b.price': 'ପ୍ରତ୍ୟେକ ଧାଡ଼ିର ଦାମ ଦରକାର।',
    'qb.b.desc': 'ଅନ୍ୟ ଶୁଳ୍କର ବିବରଣୀ ଲେଖନ୍ତୁ।',
    'qb.b.cash': 'ମିଳିଥିବା ନଗଦ ବିଲଠାରୁ କମ।',
  },
})
